
import api from '@/services/api';
import _ from 'underscore';
import {Module} from 'vuex';
import {RootState} from '@/types';
import Certification from '@/classes/Certification';

export interface CertificationState {
    certifications: Certification[];
}

export const CertificationStore: Module<CertificationState, RootState> = {
    namespaced: true,

    state: {
        certifications: []
    },

    getters: {
        getCertifications(state) {
            return state.certifications;
        },

        getCertificationById: (state) => (id: number): Certification | undefined => {
            return _.find(state.certifications, (c: Certification) => {
                return c.id === id;
            });
        }
    },

    mutations: {
        setCertifications(state, certifications: Certification[]) {
            state.certifications = certifications;
        }
    },

    actions: {

    }
};
